import React, { Component } from "react";
import { withRouter } from 'react-router-dom';
import "./style.css";
import "../../../../../index.css";
/**
 * 这是用于通过专业查询院校的顶部搜索框
 */
class MajorQuerySearchBox extends Component {
  constructor(props) {
    super(props);
    this.state = {};
  }
  render() {
    const { placeholder, handleVisibleFilter, visible, name } = this.props;
    return (
      <div
        className={
          visible === true
            ? "majorquerySearch_box"
            : "majorquerySearch_box display_none"
        }
      >
        <div className="majorquerySearch_box_left fl">
          <div className="majorquerySearch_box_left_div">
            <div className="majorquerySearch_box_left_div_img fl">
              <img
                alt=""
                src={require("../../../../../images/search/search_2.png")}
              ></img>
            </div>
            <div className="majorquerySearch_box_left_div_input fl">
              <input
                onClick={this.handleVisibleSearch}
                placeholder={placeholder}
                value={name}
                readOnly
              ></input>
            </div>
          </div>
        </div>
        <div
          onClick={handleVisibleFilter}
          className="majorquerySearch_box_right fl"
        >
          <div className="majorquerySearch_box_right_img fl">
            <img
              alt=""
              src={require("../../../../../images/search/search_1.png")}
            ></img>
          </div>
          <div className="majorquerySearch_box_right_txt fl">筛选</div>
        </div>
        <div className="clear"></div>
      </div>
    );
  }
  handleVisibleSearch = () => {
    this.props.history.push("/majorquery/search?from=/majorquery/list");
  };
}

export default withRouter(MajorQuerySearchBox);



// WEBPACK FOOTER //
// ./src/containers/MajorQuerySchool/SchoolList/components/MajorQuerySearchBox/index.js